import Sidebar from "./pages/sidebar";

const Main = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex min-h-screen items-start">
        <aside className="sticky top-0 h-screen bg-[#1E293B]">
          <Sidebar />
        </aside>

        <main className="flex-1 bg-gray-100 min-h-screen p-4">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Main;
